// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-4dbb93d1]:export{primaryColor:#00a0df;secondaryColor:#003479;accentColor:#c41230}", ""]);
// Exports
module.exports = exports;
